import {IEmployment} from "@/dto/payroll/IEmployment";
import {Vue} from "vue-property-decorator";

export class EmploymentVue<T extends IEmployment> extends Vue{
    employment!: T
}